export enum CommunicatorEvents {
  Emote = "emote",
  SystemChat = "systemchat",
}
